import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export enum Paths {
  HOME = "/home",
  SESSION = "/sessions/",
  ACCOUNTS = "/accounts",
  HISTORY = "/sessions-history",
}

const PATHS = [
  { pathName: Paths.HOME, tabName: "Home" },
  { pathName: Paths.SESSION, tabName: "Sessions" },
  { pathName: Paths.ACCOUNTS, tabName: "Accounts" },
  { pathName: Paths.HISTORY, tabName: "History" },
];

const useHeaderNavigationBar = () => {
  const [currentTab, setCurrentTab] = useState("");
  const { pathname } = useLocation();

  useEffect(() => {
    PATHS.forEach(({ pathName, tabName }) => {
      if (pathname.includes(pathName) && currentTab !== tabName) {
        setCurrentTab(tabName);
      }
    });
  }, [currentTab, pathname]);

  return { currentTab };
};

export default useHeaderNavigationBar;
